import { rIC } from "../../utils";

function giftCardLandingController() {
  if (document.querySelector(".gift-card-landing")) {
    void import("./gift-card-landing");
  }
}

const index = () => rIC(giftCardLandingController);
export default index;
